<template>
    <div>
        <div style="height:45px"></div>
        <my_menu2 page_name="服务人数看板" back_type="close" back_icon="md-close"></my_menu2>
        <div>

            <Spin fix v-if="loading">
                <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
                <div>玩命加载中,预计需2分钟</div>
            </Spin>
            <div class="tabs">
                <Tabs type="card" v-model="dep_1" @on-click="dep_click_1">
                    <TabPane :name="item.value" :label="item.label" v-for="(item, i) in dep_list" :key="i">
                        <div class="tabs_dep">

                        </div>
                    </TabPane>
                </Tabs>
                <div>
                    <span class="export_btn" @click="export_table">导出表格</span>
                    <span class="export_btn" @click="export_table2">导出提成表格</span>
                </div>

            </div>
            <div class="table_data">
                <Table ref='table' size="small" :height="windowHeight - 100" :columns="columns" :data="table_data">
                    <template #export_xls="{ row }">
                        <span class="export_xls" @click="export_xls(row)">下载表格</span>
                    </template>
                    <template #project_count="{ row }">
                        <span class="export_xls" @click="click_project_count(row)">{{ row.project_count }}个项目</span>
                    </template>
                </Table>
            </div>

        </div>
        <Modal v-model="show_project_count" title="关联归属项目" width="300">
            <div>
                <div v-for="(item, i) in project_count_list" :key="i">{{ item }}</div>
            </div>
        </Modal>
    </div>
</template>

<script>
import my_menu2 from "@/component/menu/menu2.vue";
import { http, get_view_file_url } from "@/utils/http.js";
export default {
    components: {
        my_menu2,
    },
    mounted() {
        this.get_dep_options();
    },
    data() {
        return {
            windowWidth: document.documentElement.clientWidth, //实时屏幕宽度
            windowHeight: document.documentElement.clientHeight, //实时屏幕高度

            //部门数据
            dep_list: [],
            dep_1: '',

            loading: false,
            table_data: [],
            columns: [],
            show_project_count: false,
            project_count_list: []
        }
    },
    methods: {
        click_project_count(item) {
            this.show_project_count = true
            this.project_count_list = item.project_name_list

        },

        export_table2() {
            var data_list = []
            for (var i = 0; i < this.table_data.length; i++) {
                var item = this.table_data[i]
                data_list.push([item.user_id, item.interview_data])
            }
            this.$Message.info('正在下载中，请稍等')
            var that = this;
            console.log(item)
            var obj = {
                data_list: data_list
            };
            http("post", process.env.VUE_APP_HOST + "/data_panel/project/service_people_ticheng_export", obj, true)
                .then((res) => {
                    if (res.code == 0) {
                        get_view_file_url(res.data.object_name)
                    } else {
                        that.$Message.error({
                            content: res.msg,
                            duration: 3,
                        });
                    }

                })
                .catch((res) => {
                    this.loading = false;
                    console.log(res, "请求出错");
                });
        },
        export_xls(item) {
            this.$Message.info('正在下载中，请稍等')
            var that = this;
            console.log(item)
            var obj = {
                interview_data: item.interview_data,
                staff_user_id: item.user_id

            };
            http("post", process.env.VUE_APP_HOST + "/data_panel/project/service_people_export", obj, true)
                .then((res) => {
                    if (res.code == 0) {
                        get_view_file_url(res.data.object_name)
                    } else {
                        that.$Message.error({
                            content: res.msg,
                            duration: 3,
                        });
                    }

                })
                .catch((res) => {
                    this.loading = false;
                    console.log(res, "请求出错");
                });
        },
        export_table() {
            this.$refs.table.exportCsv({
                filename: '服务人数看板导出'
            });
        },

        dep_click_1() {
            this.get_table_data()
        },
        //获取表格数据
        get_table_data() {
            var that = this;
            this.loading = true;
            var obj = {
                dep_team_id: this.dep_1,
            };
            http("post", process.env.VUE_APP_HOST + "/data_panel/project/service_people_table_data", obj, true)
                .then((res) => {
                    if (res.code == 0) {
                        that.columns = res.data.columns;
                        that.table_data = res.data.table_data;
                    } else {
                        that.$Message.error({
                            content: res.msg,
                            duration: 3,
                        });
                    }
                    this.loading = false;
                })
                .catch((res) => {
                    this.loading = false;
                    console.log(res, "请求出错");
                });
        },

        get_dep_options() {
            var that = this;
            var obj = {};
            http(
                "post",
                process.env.VUE_APP_HOST + "/data_panel/project/service_people_dep_options",
                obj,
                true
            )
                .then((res) => {
                    if (res.code == 0) {
                        that.dep_list = res.data.data_list;

                        this.dep_1 = that.dep_list[0]["value"];
                        this.get_table_data();

                    } else {
                        that.$Message.error({
                            content: res.msg,
                            duration: 3,
                        });
                    }
                })
                .catch((res) => {
                    console.log(res, "请求出错");
                });
        },
    }
}
</script>

<style scoped>
.export_xls {
    color: #0f87ff;
    cursor: pointer;
}

.demo-spin-col .circular {
    width: 25px;
    height: 25px;
}

.demo-spin-icon-load {
    animation: ani-demo-spin 1s linear infinite;
}

@keyframes ani-demo-spin {
    from {
        transform: rotate(0deg);
    }

    50% {
        transform: rotate(180deg);
    }

    to {
        transform: rotate(360deg);
    }
}

.demo-spin-col {
    height: 100px;
    position: relative;
    border: 1px solid #eee;
}

.export_btn {
    margin-right: 10px;
    font-size: 13px;
    color: #0f87ff;
    cursor: pointer;
}

.tabs {
    display: flex;
    justify-content: space-between;
}

.main {
    background: #f5f7f9;
}
</style>